// extracted by mini-css-extract-plugin
export default {"image":"image-VkYnR9s_","loadingContainer":"loadingContainer-zayAJQFk","loading":"loading-j7lZFt7z","errorContainer":"errorContainer-mGtZOqw4"};